import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

import { MxPropertyName } from '@axon-enterprise/track';

@Component({
  selector: 'sn-drawer, [snDrawer]',
  templateUrl: './drawer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'sn-drawer',
  },
})
export class SnDrawerComponent implements AfterViewInit {
  @Input() public resizable: boolean = false;
  @Input() public name: string;
  @Output() public metricTriggered = new EventEmitter<{
    [MxPropertyName.FususPanelAction]: string;
    [MxPropertyName.Action]: string;
  }>();
  public resizeStyle: any = {};
  public isFullscreen: boolean = false;

  constructor() {}

  public ngAfterViewInit(): void {
    const container: any = document.querySelector('.sn-drawer-container');
    const resizeBtn: any = document.querySelector('.resize-drawer-btn');
    const draggableBtn: any = document.querySelector('.draggable-drawer-btn');
    if (resizeBtn && draggableBtn) {
      resizeBtn.style.right = `calc(${container.style.width} - 12px)`;
      draggableBtn.style.right = `calc(${container.style.width} - 12px)`;
    }
  }

  public resizeValidate(event: any): boolean {
    const w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    const vw = (90 * w) / 100;
    if (event.rectangle.width < 380 || event.rectangle.width >= vw) {
      return false;
    }
    return true;
  }

  public onResizeEnd(event: any): void {
    const w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    const vw = (90 * w) / 100;
    const container: any = document.querySelector('.sn-drawer-container');
    const drawer: any = document.querySelector('.sn-drawer');
    const resizeBtn: any = document.querySelector('.resize-drawer-btn');
    const draggableBtn: any = document.querySelector('.draggable-drawer-btn');
    const left = `${event.rectangle.left}px`;
    const top = `${event.rectangle.top}px`;
    const width = `${event.rectangle.width}px`;
    const height = `${event.rectangle.height}px`;
    container.style.width = width;
    drawer.style.width = width;
    resizeBtn.style.right = `calc(${width} - 12px)`;
    draggableBtn.style.right = `calc(${width} - 12px)`;
    this.resizeStyle = {
      position: 'fixed',
      left,
      top,
      width,
      height,
    };
    this.isFullscreen = Number(event.rectangle.width) + 4 >= vw;
  }

  public toggleResize(): void {
    const container: any = document.querySelector('.sn-drawer-container');
    const drawer: any = document.querySelector('.sn-drawer');
    const resizeBtn: any = document.querySelector('.resize-drawer-btn');
    const draggableBtn: any = document.querySelector('.draggable-drawer-btn');
    if (!this.isFullscreen) {
      container.style.width = '90vw';
      drawer.style.width = '90vw';
      resizeBtn.style.right = 'calc(90vw - 12px)';
      draggableBtn.style.right = 'calc(90vw - 12px)';
      this.resizeStyle = {
        width: '90vw',
        'min-width': '0px',
        'max-width': '90vw',
      };
      this.isFullscreen = true;
      this.metricTriggered.emit({
        [MxPropertyName.FususPanelAction]: 'Expand',
        [MxPropertyName.Action]: 'Resize',
      });
    } else {
      container.style.width = '380px';
      drawer.style.width = '380px';
      resizeBtn.style.right = 'calc(380px - 12px)';
      draggableBtn.style.right = 'calc(380px - 12px)';
      this.resizeStyle = {
        width: '380px',
        'min-width': '380px',
        'max-width': '90vw',
      };
      this.isFullscreen = false;
      this.metricTriggered.emit({
        [MxPropertyName.FususPanelAction]: 'Collapse',
        [MxPropertyName.Action]: 'Resize',
      });
    }
  }

  public trackDraggableBtnClick(): void {
    this.metricTriggered.emit({
      [MxPropertyName.FususPanelAction]: 'Drag',
      [MxPropertyName.Action]: 'Resize',
    });
  }
}
